import { get_storageForders } from 'global/storage/storageFolders'
import React, { useCallback, useContext } from 'react'
import { ParentContext } from '../ParentContext';
import { getAllImagesInPath } from 'global/storage/storageHelpers';
import { _cacheGroupTypes } from './useTimestamp';

export const useFileManagement = ({ setPropUrls, handleFinished, setUpdating }) => {

  const parentContext = useContext(ParentContext);
  const { states, fns, fn_cls } = parentContext ?? {}
  const { app_state, paps_state } = states
  const { database_fns } = fns ?? {}
  const { pathViews } = paps_state
  const { app_prods } = app_state ?? {}
  const { prodStorage } = app_prods ?? {}

  const handleGet_prodStorage = useCallback(async () => {
    const cbs = (res) => setPropUrls(res)
    const cb = (res) => {
      const { folderItems } = res
      const { manifests } = folderItems ?? {}
      if (manifests?.fullPath) {
        getAllImagesInPath(prodStorage, manifests.fullPath, cbs)
      }
      // 
    }
    get_storageForders(prodStorage, pathViews, {}, cb)
  }, [])

  const handleUpdate_globalUrls = useCallback(async () => {
    const cb = (res) => {
      handleFinished(res)
      const _timestamp = Date.now()
      database_fns.update_timestamp(_cacheGroupTypes.urls, pathViews.events, _timestamp)
    }
    setUpdating(true)
    await fn_cls.syncEventImages(pathViews, cb);
  }, []);

  const handleUpdate_profileGlobalUrls = useCallback(async () => {
    const cb = (res) => {
      const _timestamp = Date.now()
      database_fns.update_timestamp(_cacheGroupTypes.appUsersInfo, pathViews.events, _timestamp)
      handleFinished(res)
    }
    setUpdating(true)
    //pathViews, callback, testOnly, urlsOnly
    await fn_cls.renameStorageImages(pathViews, cb, false, true)
  }, []);

  const handleUpdate_updateImageThumbnails = useCallback(async () => {
    const cb = (res) => handleFinished(res)
    setUpdating(true)
    // pathViews, handleFinished, testOnly, urlsOnly
    await fn_cls.updateImageThumbnails(pathViews, cb)
  }, []);

  const handleUpdate_moveToGlobal = useCallback(async () => {
    const cb = (res) => handleFinished(res)
    setUpdating(true)
    await fn_cls.moveToGlobal(pathViews, cb)
  }, []);

  const handleUpdate_renameStorageImages = useCallback(async () => {
    const cb = (res) => handleFinished(res)
    setUpdating(true)
    await fn_cls.renameStorageImages(pathViews, cb)
  }, []);

  const handleUpdate_testRenameStorageImages = useCallback(async () => {
    const cb = (res) => handleFinished(res)
    setUpdating(true)
    await fn_cls.renameStorageImages(pathViews, cb, true)
  }, []);

  const handleUpdate_moveDirectToPages = useCallback(async () => {
    const cb = (res) => handleFinished(false)
    setUpdating(true)
    await fn_cls.moveDirectToPages(pathViews, cb)
    // await fn_cls.generateAllManifests(database_fns, mainStorage, projectIds)
  }, []);

  return {
    handleGet_prodStorage,
    handleUpdate_globalUrls,
    handleUpdate_profileGlobalUrls,
    handleUpdate_updateImageThumbnails,
    handleUpdate_moveToGlobal,
    handleUpdate_renameStorageImages,
    handleUpdate_testRenameStorageImages,
    handleUpdate_moveDirectToPages
  }
}
